<template>
  <HPopup class="h-arena"
          :zIndex="9"
          :borderIndex="6"
          :class="{'is-mobile': isMobile}"
          ref="popup"
          v-show="visible">
    <div class="h-popup-body">
      <!--<p class="popup-header">竞技场</p>-->

      <div class="room-panel" :class="{ 'is-mobile': isMobile }">
        <div class="room-wrapper">
          <!-- 在房间里 -->
          <template v-if="roomInfo">
            <Room ref="room" v-on="$listeners" @showDifficultyPopup="handleShowDifficultyPopup"></Room>
          </template>
          <!-- 不在房间里 -->
          <template v-else>
            <div class="buttons">
              <div v-click-sound-button class="btn-create-room h-btn primary" @click="createRoomShow=true">创建房间</div>
              <div v-click-sound-button class="btn-leave-room h-btn primary" @click="handleClose">离开</div>
            </div>
            <div class="title h-outer-border around-4 bw3 h-bg blue-2">房间列表</div>
            <!-- 房间列表 -->
            <RoomList></RoomList>
          </template>
        </div>

        <!-- 创建房间 -->
        <HCreateRoomPopup
          :visible.sync="createRoomShow"
          @alert="alert"
          @submit="submitCreateRoom">
        </HCreateRoomPopup>

        <!-- 电脑难度选择 -->
        <HAlert class="difficulty-popup"
                :borderIndex="6"
                theme="blue"
                :visible.sync="difficultyShow">
          <div class="difficulty-value h-outer-border around-4 h-bg blue-2 bz0 bw3">
            <span class="gold">电脑难度：</span>
            <span class="white">{{ AIDifficulty * 100 }}%</span>
          </div>
          <div class="difficulty-buttons h-outer-border around-4 bw2">
            <div class="h-title"
                 :data-title="item.title"
                 v-for="item in difficultyLevels"
                 :class="[item.value === AIDifficulty ? 'selected' : '']">
              <button v-click-sound-button
                      class="h-button difficulty"
                      :class="[item.class]"
                      @click="AIDifficulty=item.value">
              </button>
            </div>
          </div>
          <!--<div class="ai-buttons h-outer-border around-4 h-bg blue-1 bz0 bw2">
            <div class="form-item-content">
              <div v-click-sound-button
                   class="check-item"
                   v-for="item in AIVersionOptions" :key="item.value"
                   :class="{ selected: AIVersion === item.value }"
                   @click="handleSelectAIVersion(item)">
                <div class="check-box h-outer-border around-4 bw2 bz0 h-bg blue-2">
                  <img v-if="AIVersion === item.value" src="/img/btn/TPTHCHKG.png"
                       alt="selected">
                </div>
                <div class="check-label">{{ item.name }}</div>
              </div>
            </div>
          </div>-->
        </HAlert>

      </div>
    </div>
  </HPopup>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import HCreateRoomPopup from '@/components/h-create-room-popup'
  import HAlert from '@/components/h-alert/index.vue'
  import RoomList from './room/room-list'
  import Room from './room/room'
  import HPopup from '@/components/h-popup/index.vue'

  const difficultyLevels = [
    { value: .8, class: 'GSPBUT3N', title: '▷ 电脑难度：80%。\n▷ 80%统帅。\n▷ 80%属性点，80%技能点。\n' },
    { value: 1, class: 'GSPBUT4N', title: '▷ 电脑难度：100%。\n▷ 100%统帅\n▷  100%属性点，100%技能点。\n' },
    {
      value: 1.3,
      class: 'GSPBUT5N',
      title: '▷ 电脑难度：130%。\n▷ 115%统帅\n▷ 115%属性点，115%技能点。'
    },
    {
      value: 1.6,
      class: 'GSPBUT6N',
      title: '▷ 电脑难度：160%。\n▷ 130%统帅\n▷ 130%属性点，130%技能点。'
    },
    {
      value: 2,
      class: 'GSPBUT7N',
      title: '▷ 电脑难度：200%。\n▷ 160%统帅\n▷ 160%属性点，160%技能点。'
    },
  ]

  const AIVersionOptions = [
    {
      name: 'AI 1.0',
      value: 1,
    },
    {
      name: 'AI 2.0 beta',
      value: 2,
    },
  ]

  export default {
    data () {
      return {
        difficultyLevels,
        AIVersionOptions,
        createRoomShow: false,
        troopsShow: false,
        shopShow: false,
        backpackShow: false,
        heroShow: false,
        rankShow: false,
        difficultyShow: false,
        addPlayerData: {}, // 队伍、位置信息
        AIDifficulty: 1,
        AIVersion: 2,
      }
    },

    computed: {
      ...mapGetters('device', [
        'isMobile',
      ]),

      ...mapGetters('user', [
        'userInfo',
      ]),

      ...mapGetters('gameSocket', [
        'roomList'
      ]),

      // 房间信息
      roomInfo () {
        return this.roomList.find(room => {
          return room.players.some((p) => {
            return p?.userId === this.userInfo.id
          }) || room.spectators.some((p) => {
            return p?.userId === this.userInfo.id
          })
        })
      },
    },

    props: {
      visible: {
        type: Boolean,
        default: true
      },
      zIndex: {
        type: Number,
        default: 1000
      },
    },

    watch: {
      difficultyShow (val) {
        if (!val) {
          this.handleAddAIPlayer()
        }
      }
    },

    mounted () {
    },

    methods: {
      ...mapActions('gameSocket', [
        'createRoom',
        'exitRoom',
        'addAIPlayer',
      ]),

      ...mapActions('gameSocket', [
        'updateChatTargetList',
      ]),

      alert (message) {
        this.$emit('alert', message)
      },

      // 创建房间
      submitCreateRoom (data) {
        this.createRoom(data)
      },

      // 添加电脑玩家
      handleAddAIPlayer () {
        if (this.roomInfo.pvpBounty) {
          this.alert('已设置悬赏金，无法添加电脑')
          return
        }
        this.addAIPlayer({
          AIDifficulty: this.AIDifficulty,
          AIVersion: this.AIVersion,
          ...this.addPlayerData
        })
      },

      // 显示电脑难度选择
      handleShowDifficultyPopup ({ teamId, index }) {
        this.difficultyShow = true
        this.addPlayerData = { teamId, index }
      },

      // 选择AI版本
      handleSelectAIVersion ({ value }) {
        this.AIVersion = +value || 1
      },

      handleClose () {
        this.$emit('close', false)
      },

    },

    components: {
      HCreateRoomPopup,
      HAlert,
      RoomList,
      Room,
      HPopup,
    }
  }

</script>

<style lang="stylus">
  .h-popup.h-arena > .h-popup-container
    color red !important
    position absolute
    left auto
    right 0
    top 0
    padding 15px 15px 20px
    width 386px
    height calc(100% - 44px)
    transform translate(0, 0)
</style>

<style lang="stylus" scoped>
  .h-popup-body
    position relative
    z-index 1
    height 100%

  /deep/ .difficulty-popup
    position absolute
    .popup-body
      width 230px
    .btn-add-ai
      color white
    .difficulty-value
      position relative
      margin-bottom 10px
      padding 3px
      line-height 24px
      font-size 14px
      text-align center
    .difficulty-buttons
      display flex
      padding 2px
      text-align center
      > div
        &:after
          display none
          width 200px
        &:hover
          z-index 2
          > button
            border-color #fff
          &:after
            display block
        > button
          vertical-align top
          border 2px solid transparent
      > div:last-child:after
        left auto
        right 0
        transform translate(0, -100%)
      > div.selected
        z-index 1
        &:hover
          &:after
            display block
        > button
          border-color $colorYellow

  .room-panel
    position relative
    width 100%
    height 100%
    &:before
      z-index 0 !important
    .room-wrapper
      position relative
      z-index 1
      margin-bottom 1px
      height 100%
      border-width 7px
      > .title
        margin-bottom -1px
        goldText()
        line-height 36px
        font-size 16px
        text-align center
        letter-spacing 1px
        &:before
          z-index 0 !important
          border-width 2px

  .sep-border-left
    &:before
      content ""
      position absolute
      z-index 1
      left 0
      top 0
      width 2px
      height 100%
      background-color #554737
      box-shadow 0 0 0 1px #241b10

  .sep-border-right
    &:after
      content ""
      position absolute
      z-index 1
      right 0
      top 0
      width 2px
      height 100%
      background-color #554737
      box-shadow 0 0 0 1px #241b10

  .buttons
    margin-bottom 10px
    display flex
    justify-content space-evenly
    .MUBCANCN
      width 64px
      height 32px
    .btn-create-room
      margin-right 10px

    .btn-create-room,
    .btn-leave-room
      width 133px
      height 32px
      line-height 32px
      font-size 16px
      font-weight bold
      letter-spacing 1px
      text-align center
      color #000
      text-shadow 1px 1px 1px #fff
      box-shadow 2px 2px 1px #000

  .ai-buttons
    margin-top 10px
    padding 2px
    .form-item-content
      position relative
      display flex
      padding 0 5px
    .check-item
      position relative
      display inline-flex
      padding 3px 0
      cursor pointer
      vertical-align middle
      .check-box
        display flex
        justify-content center
        align-items center
        width 30px
        height 30px
        padding 3px
        img
          max-width 100%
      &:not(:last-child)
        margin-right 30px
      .check-label
        padding-left 5px
        line-height 30px
        font-size 12px
        letter-spacing 1px
        goldText1()

</style>
